import React, { useState } from "react";
import "./ContactUsInfo.css";
import { useDispatch } from "react-redux";
import { addContactUsAPI } from "../../../../store/action/contactAction";
import { toast } from "react-toastify";

const ContactUsInfo = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState("");

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Restrict phone input to digits only
    if (name === "phone") {
      const numericValue = value.replace(/\D/g, "").slice(0, 10);
      setFormData({ ...formData, phone: numericValue });
      setErrors({ ...errors, phone: "" });
      return;
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  // Validate form
  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Invalid email address";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required"; // required
    } else if (!/^[0-9]{10}$/.test(formData.phone.trim())) {
      newErrors.phone = "Phone number must be 10 digits";
    }

    if (!formData.message.trim()) newErrors.message = "Message is required";

    return newErrors;
  };

  // Handle submit
  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    setApiError("");
    setSuccess("");

    const payload = {
      user_name: formData.name,
      user_mobile_number: formData.phone,
      user_email: formData.email,
      message: formData.message,
    };

    dispatch(
      addContactUsAPI(payload, (result) => {
        if (result?.status) {
          toast.success(result?.message?.message);
          setSuccess("Thank you! Your request has been submitted.");
          setFormData({ name: "", email: "", phone: "", message: "" });
          setLoading(false);
        } else {
          setLoading(false);
        }
      }),
    );
  };

  return (
    <section className="contact-section">
      <div className="contact-grid">
        {/* LEFT SIDE */}
        <div className="contact-left">
          <h2>Get in Touch</h2>
          <p>
            Have an idea, project, or business challenge? Let’s talk and turn it
            into a powerful digital solution.
          </p>

          <div className="contact-details">
            <p>
              <strong>Email:</strong> bacodesolutionsofficial@gmail.com
            </p>
            <p>
              <strong>Phone:</strong> +91 99748 94099
            </p>
            <p>
              <strong>Website:</strong> www.bacodesolutions.com
            </p>
          </div>

          <div className="business-hours">
            <h4>Business Hours</h4>
            <p>Monday – Saturday</p>
            <p>10:00 AM – 7:00 PM (IST)</p>
          </div>

          <div className="contact-note">
            👉 Let’s digitize your jewellery business — the right way.
          </div>
        </div>

        {/* RIGHT SIDE (FORM) */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <h3>Let’s Build Something Together</h3>
          <div className="input-wrapper">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && <span className="error">{errors.name}</span>}
          </div>
          <div className="input-wrapper">
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <span className="error">{errors.email}</span>}
          </div>
          <div className="input-wrapper">
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              maxLength={10}
            />
            {errors.phone && <span className="error">{errors.phone}</span>}
          </div>

          <div className="input-wrapper">
            <textarea
              name="message"
              placeholder="Tell us about your project..."
              rows="4"
              value={formData.message}
              onChange={handleChange}
            />
            {errors.message && <span className="error">{errors.message}</span>}
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit Request"}
          </button>

          {success && <p className="success">{success}</p>}
        </form>
      </div>
    </section>
  );
};

export default ContactUsInfo;
